// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"52718513","390":"069140a7"}[chunkId] + ".chunk.js";
};